import { ofType, combineEpics } from 'redux-observable';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { startWithEndWith, NO_OP } from 'middleware/utils';
import {
  getNoteListSuccess,
  getNoteListError,
  deleteNoteItemSuccess,
  toggleNoteListLoading,
  updateNoteItemSuccess,
} from 'store/noteList/actions';
import {
  GET_NOTE_LIST,
  CREATE_NOTE_ITEM,
  DELETE_NOTE_ITEM,
  UPDATE_NOTE_ITEM,
  getNoteList,
} from './actions';

const getNoteListEpic = (action$, state$, { noteRequest }) => action$.pipe(
  ofType(GET_NOTE_LIST),
  mergeMap(() => noteRequest.getNoteList$().pipe(
    mergeMap((response) => {
      const { data } = response;
      return of(getNoteListSuccess(data));
    }),
    catchError(error => of(getNoteListError(error))),
    startWithEndWith(toggleNoteListLoading(true), toggleNoteListLoading(false)),
  )),
  catchError(error => of(getNoteListError(error))),
);

const createNoteItemEpic = (action$, state$, { noteRequest }) => action$.pipe(
  ofType(CREATE_NOTE_ITEM),
  mergeMap((params) => {
    const { payload } = params;
    const { message } = payload;
    return noteRequest.createNote$(message).pipe(
      mergeMap(response => of(getNoteListSuccess(response))),
      catchError(error => of(getNoteListError(error))),
    );
  }),
  catchError(error => of(getNoteListError(error))),
);

const updateNoteItemEpic = (action$, state$, { noteRequest }) => action$.pipe(
  ofType(UPDATE_NOTE_ITEM),
  mergeMap((params) => {
    const { payload } = params;
    const { id, message } = payload;
    if (id) {
      return noteRequest.updateNote$(id, message).pipe(
        mergeMap(response => of(updateNoteItemSuccess(response.data))),
        catchError(() => of(NO_OP)),
        startWithEndWith(toggleNoteListLoading(true), toggleNoteListLoading(false)),
      );
    }
    return noteRequest.createNote$(message).pipe(
      mergeMap(response => of(updateNoteItemSuccess(response.data))),
      catchError(() => of(NO_OP)),
      startWithEndWith(toggleNoteListLoading(true), toggleNoteListLoading(false)),
    );
  }),
  catchError(() => of(NO_OP)),
);

const deleteNoteItemEpic = (action$, state$, { noteRequest }) => action$.pipe(
  ofType(DELETE_NOTE_ITEM),
  mergeMap((params) => {
    const { payload } = params;
    const { id } = payload;
    return noteRequest.deleteNote$(id).pipe(
      mergeMap(() => of(
        deleteNoteItemSuccess(id),
        getNoteList(),
      )),
      catchError(() => of(NO_OP)),
      startWithEndWith(toggleNoteListLoading(true), toggleNoteListLoading(false)),
    );
  }),
  catchError(() => of(NO_OP)),
);

export default combineEpics(
  getNoteListEpic,
  createNoteItemEpic,
  deleteNoteItemEpic,
  updateNoteItemEpic,
);
